import { Tag } from 'antd';
import 'antd/es/tag/style/index';
import './index.less';

export default Tag;
